export const KEEP_SESSION_ALIVE_INTERVAL_MS = 10000
